
function Navigation() {

    this.build();

}

Navigation.prototype.build = function(){

    let that = this;

    $('.header-main__toggle').on('click', function(e){
        e.stopPropagation();
        e.preventDefault();

        $('body').toggleClass('main-nav--open');

        if( ! $('body').hasClass('main-nav--open') ){
            that.close();
        }
    });

    document.querySelectorAll('.header-main__toggle__word--menu, .header-main__toggle__word--close').forEach(function (elem) {
        var splitText = new SplitText(elem, {
            type: "chars, words, lines",
            wordsClass: "split-words",
            charsClass: "split-chars"
        });

        splitText.chars.forEach(function (char, index){
            char.style.transitionDelay = 0.05 + index / 50 + 's';
        });
    });

    $('.has-subnav').on('click', function(e){
        e.stopPropagation();
        e.preventDefault();

        $(this).next('.nav-main__lev2').addClass('is-visible');
        $('body').addClass('main-subnav--open');
    });

    $('.subnav-main__close').on('click', function(e){
        e.stopPropagation();
        e.preventDefault();

        $('.nav-main__lev2').removeClass('is-visible');
        $('body').removeClass('main-subnav--open');
    });

    $('.header-main__nav__overlay').on('click', function(e){
        that.close();
    });

};

Navigation.prototype.close = function(){

    $('.nav-main__lev2').removeClass('is-visible');
    $('body').removeClass('main-subnav--open');
    $('body').removeClass('main-nav--open');

};